(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var elements = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
    if (!elements.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      elements.forEach(function (el) {
        el.style.setProperty('--progress', 1);
      });
      return;
    }

    // Ease-out: motion is fast at first and settles in, rather than moving
    // linearly at exactly the speed of the scrollbar.
    function ease(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    var active = new Set();
    var rafId = null;

    function tick() {
      rafId = null;
      var vh = window.innerHeight;

      active.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        // progress 0 -> element just entering at the bottom of the viewport
        // progress 1 -> element has scrolled up to ~60% of viewport height
        var start = vh * 0.95;
        var end = vh * 0.6;
        var raw = (start - rect.top) / (start - end);
        raw = Math.min(Math.max(raw, 0), 1);
        el.style.setProperty('--progress', ease(raw));

        if (raw >= 1) {
          active.delete(el);
          observer.unobserve(el);
        }
      });

      if (active.size > 0) {
        rafId = requestAnimationFrame(tick);
      }
    }

    function ensureLoop() {
      if (rafId === null && active.size > 0) {
        rafId = requestAnimationFrame(tick);
      }
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            active.add(entry.target);
          } else {
            active.delete(entry.target);
          }
        });
        ensureLoop();
      },
      { threshold: 0 }
    );

    elements.forEach(function (el) {
      el.style.setProperty('--progress', 0);
      observer.observe(el);
    });
  }

  // Wait for full page load (images, video, fonts) so section positions are
  // settled before measuring scroll progress against them.
  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init);
  }
})();
